import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../Dashboard/_services/users.service';
import { AlertService } from '../../Dashboard/_services/alert.service';

// Delivery/dispatch pages are role-based (DELIVERY, or ADMIN/SALEADMIN/
// S-ADMIN who can reach everything) rather than restricted to one
// hardcoded email like purchases.guard.ts/analytics.guard.ts used to be -
// dispatch team accounts are meant to be created with only the DELIVERY
// role, see delivery-team.component.ts.
export const deliveryGuard = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  const userInfo = userService.isLoggedIn();
  const roles = (userInfo.userrole ?? '').split(',');
  if (
    userInfo.isLoggedIn &&
    (roles.includes('DELIVERY') ||
      roles.includes('ADMIN') ||
      roles.includes('SALEADMIN') ||
      roles.includes('S-ADMIN'))
  ) {
    return true;
  }
  alertService.alert('You do not have permission to access this page', 'error');
  return router.navigate(['/sales']);
};

// Managing who has the DELIVERY role is admin-level - a DELIVERY account
// itself shouldn't be able to create more delivery accounts.
export const deliveryTeamGuard = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  const userInfo = userService.isLoggedIn();
  const roles = (userInfo.userrole ?? '').split(',');
  if (
    userInfo.isLoggedIn &&
    (roles.includes('ADMIN') || roles.includes('SALEADMIN') || roles.includes('S-ADMIN'))
  ) {
    return true;
  }
  alertService.alert('You do not have permission to access this page', 'error');
  return router.navigate(['/sales']);
};
